// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    margin: 30px 0px;
}

td {
    text-align: center;
    cursor: pointer;
}

.table-title {
    display: flex;
    justify-content: center;
}

.major-course-table {
    padding: 0px !important;
    width: 40rem !important;
}

.disabled {
    color: #8794a1 !important;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/Majorcourse/MajorCourse.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".title {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 30px 0px;\r\n}\r\n\r\ntd {\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.table-title {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.major-course-table {\r\n    padding: 0px !important;\r\n    width: 40rem !important;\r\n}\r\n\r\n.disabled {\r\n    color: #8794a1 !important;\r\n    cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
